import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OEAnatomyTargetType = {
    anatomy:        'anatomy',
    head:           'head',
    biology:        'biology',
    organs:         'organs',
};

OEAnatomyTargetType.all = [
    OEAnatomyTargetType.anatomy,
    OEAnatomyTargetType.head,
    OEAnatomyTargetType.biology,
    OEAnatomyTargetType.organs
];

export const OEAnatomyStartSelectionContent = {
    [OEAnatomyTargetType.anatomy]: [
        {
            subcategories: [
                {
                    items: [
// @ADD_TARGET_ANATOMY_TARGETMENU
                        OETargetMenuDefs.humanPatient,
                        OETargetMenuDefs.humanBones,
                        OETargetMenuDefs.humanArm,
                        OETargetMenuDefs.humanShoulderGirdle,
                        OETargetMenuDefs.humanUpperArmElbow,
                        OETargetMenuDefs.humanForearm,
                        OETargetMenuDefs.humanHand
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanLeg,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanLowerLeg,
                        OETargetMenuDefs.humanAnkleFoot
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanTrunk,
                        OETargetMenuDefs.humanNeckBack,
                        OETargetMenuDefs.humanChestWall,
                        OETargetMenuDefs.humanAbdominalWall,
                        OETargetMenuDefs.humanPelvis,
                        OETargetMenuDefs.humanSpine,
                        OETargetMenuDefs.humanSpineFracture2
                    ]
                }
            ]
        }
    ],
    [OEAnatomyTargetType.head]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanSkull,
                        OETargetMenuDefs.humanHead,
                        OETargetMenuDefs.humanHeadWIP,
                        OETargetMenuDefs.humanCNS,
                        OETargetMenuDefs.humanCNSWIP,
                        OETargetMenuDefs.humanCranialNerves,
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeLid,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.humanEarMacro,
                        OETargetMenuDefs.humanEarInner,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.humanLarynx
                    ]
                }
            ]
        }
    ],
    [OEAnatomyTargetType.organs]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanTrunkVessel,
                        OETargetMenuDefs.humanRespiratorySystem,
                        OETargetMenuDefs.humanBronchialTree,
                        OETargetMenuDefs.humanRespiratoryEpithelium,
                        OETargetMenuDefs.humanGenitalMale,
                        OETargetMenuDefs.humanMuscleSpindle,
                    ]
                }
            ]
        }
    ],
    [OEAnatomyTargetType.biology]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanCellEpithelium,
                        OETargetMenuDefs.humanBrainSynapse,
                        OETargetMenuDefs.humanSkinEpidermis,
                        OETargetMenuDefs.humanSkin2,
                        OETargetMenuDefs.virusSarscov2
                    ]
                }
            ]
        }
    ],

    [OEAnatomyTargetType.anatomy + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanArm,
                        OETargetMenuDefs.humanShoulderGirdle,
                        OETargetMenuDefs.humanUpperArmElbow,
                        OETargetMenuDefs.humanForearm,
                        OETargetMenuDefs.humanHand
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanLeg,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanLowerLeg,
                        OETargetMenuDefs.humanAnkleFoot
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanTrunk,
                        OETargetMenuDefs.humanNeckBack,
                        OETargetMenuDefs.humanChestWall,
                        OETargetMenuDefs.humanAbdominalWall,
                        OETargetMenuDefs.humanPelvis,
                        OETargetMenuDefs.humanSpine
                    ]
                }
            ]
        }
    ],
    [OEAnatomyTargetType.head + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanSkull,
                        OETargetMenuDefs.humanHead,
                        OETargetMenuDefs.humanCNS,
                        OETargetMenuDefs.humanCranialNerves,
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeLid,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.humanEarMacro,
                        OETargetMenuDefs.humanEarInner,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.humanLarynx
                    ]
                }
            ]
        }
    ],
    [OEAnatomyTargetType.organs + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanTrunkVessel
                    ]
                }
            ]
        }
    ],
    [OEAnatomyTargetType.biology + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanCellEpithelium,
                        OETargetMenuDefs.virusSarscov2
                    ]
                }
            ]
        }
    ],

    [OEAnatomyTargetType.anatomy + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanArm,
                        OETargetMenuDefs.humanShoulderGirdle,
                        OETargetMenuDefs.humanUpperArmElbow,
                        OETargetMenuDefs.humanForearm,
                        OETargetMenuDefs.humanHand
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanLeg,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanLowerLeg,
                        OETargetMenuDefs.humanAnkleFoot
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanTrunk,
                        OETargetMenuDefs.humanNeckBack,
                        OETargetMenuDefs.humanChestWall,
                        OETargetMenuDefs.humanAbdominalWall,
                        OETargetMenuDefs.humanPelvis,
                        OETargetMenuDefs.humanSpine
                    ]
                }
            ]
        }
    ],
    [OEAnatomyTargetType.head + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanSkull,
                        OETargetMenuDefs.humanHead,
                        OETargetMenuDefs.humanCNS,
                        OETargetMenuDefs.humanCranialNerves,
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeLid,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.humanEarMacro,
                        OETargetMenuDefs.humanEarInner,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.humanLarynx
                    ]
                }
            ]
        }
    ],
    [OEAnatomyTargetType.organs + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanTrunkVessel
                    ]
                }
            ]
        }
    ],
    [OEAnatomyTargetType.biology + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanCellEpithelium,
                        OETargetMenuDefs.virusSarscov2
                    ]
                }
            ]
        }
    ]
};

OEAnatomyStartSelectionContent.modules = [
    {id: OEAnatomyTargetType.head, icon: OEIconCodes.anatomy.headTarget, categories: OEAnatomyStartSelectionContent[OEAnatomyTargetType.head]},
    {id: OEAnatomyTargetType.anatomy, icon: OEIconCodes.anatomy.anatomyTarget, categories: OEAnatomyStartSelectionContent[OEAnatomyTargetType.anatomy]},
    {id: OEAnatomyTargetType.organs, icon: OEIconCodes.anatomy.organsTarget, categories: OEAnatomyStartSelectionContent[OEAnatomyTargetType.organs]},
    {id: OEAnatomyTargetType.biology, icon: OEIconCodes.anatomy.biologyTarget, categories: OEAnatomyStartSelectionContent[OEAnatomyTargetType.biology]}
];

OEAnatomyStartSelectionContent.modulesBeta = [
    {id: OEAnatomyTargetType.head, icon: OEIconCodes.anatomy.headTarget, categories: OEAnatomyStartSelectionContent[OEAnatomyTargetType.head + OEAlphaBetaProdTypes.beta]},
    {id: OEAnatomyTargetType.anatomy, icon: OEIconCodes.anatomy.anatomyTarget, categories: OEAnatomyStartSelectionContent[OEAnatomyTargetType.anatomy + OEAlphaBetaProdTypes.beta]},
    {id: OEAnatomyTargetType.organs, icon: OEIconCodes.anatomy.organsTarget, categories: OEAnatomyStartSelectionContent[OEAnatomyTargetType.organs + OEAlphaBetaProdTypes.beta]},
    {id: OEAnatomyTargetType.biology, icon: OEIconCodes.anatomy.biologyTarget, categories: OEAnatomyStartSelectionContent[OEAnatomyTargetType.biology + OEAlphaBetaProdTypes.beta]}
];

OEAnatomyStartSelectionContent.modulesProduction = [
    {id: OEAnatomyTargetType.head, icon: OEIconCodes.anatomy.headTarget, categories: OEAnatomyStartSelectionContent[OEAnatomyTargetType.head + OEAlphaBetaProdTypes.prod]},
    {id: OEAnatomyTargetType.anatomy, icon: OEIconCodes.anatomy.anatomyTarget, categories: OEAnatomyStartSelectionContent[OEAnatomyTargetType.anatomy + OEAlphaBetaProdTypes.prod]},
    {id: OEAnatomyTargetType.organs, icon: OEIconCodes.anatomy.organsTarget, categories: OEAnatomyStartSelectionContent[OEAnatomyTargetType.organs + OEAlphaBetaProdTypes.prod]},
    {id: OEAnatomyTargetType.biology, icon: OEIconCodes.anatomy.biologyTarget, categories: OEAnatomyStartSelectionContent[OEAnatomyTargetType.biology + OEAlphaBetaProdTypes.prod]}
];